import React, { useState } from "react";

export const SortOrder = ({
  sortOrder,
  setSortOrder,
  options,
  translations,
}) => {
  const [visible, setVisible] = useState(false);
  const sortAfterText = translations?.find(
    (translation) => translation.Key === "SortAfter"
  );
  const filteredOptions =
    sortOrder != null
      ? options?.filter((option) => option !== sortOrder)
      : options?.filter((option) => option.SysName !== "PublishDateDesc");

  return (
    <div className="select_wrap">
      {sortAfterText?.Translation}
      <div className="select_sortorder" onClick={() => setVisible(!visible)}>
        <div className={visible ? "sort_text visible" : "sort_text"}>
          {sortOrder ? (
            <p>{sortOrder?.TranslatedName}</p>
          ) : (
            <p>{options?.[0].TranslatedName}</p>
          )}
        </div>
        <ul className={visible ? "visible" : ""}>
          {filteredOptions?.map((option) => (
            <li key={option.ID} onClick={() => setSortOrder(option)}>
              {option.TranslatedName}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
